// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"adc0d63a","81":"fb59d070","519":"d241363d","773":"684677f5","787":"6cbebd58"}[chunkId] + ".chunk.js";
};